import { gql } from '@apollo/client';

export default gql`
  query Subscription($subscription_type: SubscriptionType!) {
    subscription(subscription_type: $subscription_type) {
      status {
        sid
        period
        next_period
        expired
        dt_expire
      }
    }
  }
`;
